import styled from '@emotion/styled';
import { Grid } from '@mui/material';
import { mediaQueryMobileLimit } from '../../../utils/constants';
import { Colors } from '../../../colors';
import Button from '../../../components/base/button/button';

export const LandingPageStyled = {
  Container: styled.div<any>`
    min-height: 100vh;
  `,
  ContainerCarousel: styled.div<any>`
   margin-top: 80px;
  
  `,
  ItemCarousel: styled.div<any>`
    background-image: ${(props: any) =>
      `linear-gradient(rgba(0, 0, 0, .2), rgba(0, 0, 0, .3)), url(${props.img})`};
    min-height: 650px;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    padding-left: 30px;
    @media (min-width: ${mediaQueryMobileLimit}px) {
      padding-left: 100px;
    }
    display: flex;
    flex-direction: column;
    justify-content: center;
  `,
  ItemCarouselText: styled.p<any>`
    font-family: EncodeSans-ExtraBold;
    color: ${(props: any) => props.color};
    font-size: 64px;
    white-space: pre-wrap;
    line-height: 5.5rem;
    @media screen and (max-width: ${mediaQueryMobileLimit}px) {
      font-size: 32px;
      line-height: 3rem;
    }
  `,
  ContainerTitlePage: styled.div<any>`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  `,
  TitlePage: styled.p<any>`
    font-family: EncodeSans-ExtraBold;
    font-size: 50px;
    text-align: center;
    margin-bottom: 2rem;
    @media screen and (max-width: ${mediaQueryMobileLimit}px) {
      font-size: 32px;
    }
  `,
  ContainerRooms: styled(Grid) <any>`
    justify-content: center;
    margin-bottom: 60px;
    margin-top: 100px;
  `,
  ContainerRoom: styled(Grid) <any>`
  display:flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  `,

  DescriptionPage: styled.p<any>`
    font-family: EncodeSans-Regular;
    font-size: 25px;
    text-align: center;
    line-height: 3rem;
    padding: 0 1rem;
    @media screen and (max-width: ${mediaQueryMobileLimit}px) {
      font-size: 18px;
      line-height: 2rem;
    }
  `,
  ContainerBooking: styled.div<any>`
    margin-top: 50px;
    padding-left: 0;
    padding-right: 0;
    @media (min-width: ${mediaQueryMobileLimit}px) {
      padding-left: 100px;
      padding-right: 100px;
    }
  `,
  ContainerServices: styled(Grid) <any>`
    display: flex;
    justify-content: center;
    margin-top: 20px;
    max-Width: 1000px;
  `,
  ContainerRowService: styled(Grid) <any>`
    
    margin-bottom: 80px;
    @media (max-width: ${mediaQueryMobileLimit}px) {
      margin-bottom: 20px;
     }
  `,
  ContainerServiceItem: styled(Grid) <any>`
    margin-bottom: 25px;
    @media (max-width: ${mediaQueryMobileLimit}px) {
      text-align: center;
     }
  `,
  TitleServices: styled.p<any>`
    font-family: EncodeSans-Bold;
    color: ${Colors.MediumBlue};
    font-size: 35px;
    margin-bottom: 80px;
  `,
  ContainerButtonService: styled(Grid) <any>`
    width: 167px;
    justify-self: center;
    display: flex;
  `,
};
